import { useState } from 'react';

const TRASH = 'trash';

// Hỏi chuyển tranh đi đâu (danh mục khác hoặc thùng rác) trước khi xoá danh mục
export default function DeleteCategoryDialog({ category, categories, onConfirm, onCancel }) {
  const options = categories.filter((c) => c.id !== category.id);
  const [targetId, setTargetId] = useState('');
  const [busy, setBusy] = useState(false);

  const confirm = async () => {
    setBusy(true);
    try {
      await onConfirm(targetId === TRASH ? TRASH : targetId ? Number(targetId) : null);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="dialog-backdrop" onClick={onCancel}>
      <div className="dialog" onClick={(e) => e.stopPropagation()} role="dialog" aria-label="Xoá danh mục">
        <h2>Xoá danh mục "{category.name}"</h2>
        <p className="muted">
          Danh mục này còn {category.artworkCount} tranh. Chọn nơi chuyển tranh tới:
        </p>
        <select value={targetId} onChange={(e) => setTargetId(e.target.value)} aria-label="Chuyển tới">
          <option value={TRASH}>🗑 Thùng rác</option>
          <option value="">— Không có danh mục —</option>
          {options.map((c) => (
            <option key={c.id} value={c.id}>
              {c.name}
            </option>
          ))}
        </select>
        <div className="dialog-actions">
          <button className="danger" onClick={confirm} disabled={busy}>
            {busy ? 'Đang xoá...' : targetId === TRASH ? 'Bỏ vào thùng rác và xoá' : 'Chuyển và xoá'}
          </button>
          <button onClick={onCancel}>Huỷ</button>
        </div>
      </div>
    </div>
  );
}
